import { EntityModel } from '@/interfaces'
import {
  ALL_PASSPORTS_DATA_QUERY,
  CREATE_PASSPORT_DATA_MUTATION,
  DELETE_PASSPORT_DATA_MUTATION,
  FORCE_DELETE_PASSPORT_DATA_MUTATION,
  SINGLE_PASSPORT_DATA_QUERY,
  UPDATE_PASSPORT_DATA_MUTATION,
} from './graphql'

const passportDataModel: EntityModel = {
  name: 'passportData',
  namePlural: 'passportsData',
  uniqueName: 'passportData',
  uniqueNamePlural: 'passportsData',
  path: 'travel/booking/passport_data',
  baseUrl: '/travel/booking/passports_data',
  translationPrefix: 'entities:passportData.',
  getDisplayName: (values: any) => {
    return values.number
  },
  gql: {
    getAll: ALL_PASSPORTS_DATA_QUERY,
    getSingle: SINGLE_PASSPORT_DATA_QUERY,
    create: CREATE_PASSPORT_DATA_MUTATION,
    update: UPDATE_PASSPORT_DATA_MUTATION,
    delete: DELETE_PASSPORT_DATA_MUTATION,
    forceDelete: FORCE_DELETE_PASSPORT_DATA_MUTATION,
  },
  attributes: {
    type: {
      name: 'type',
      label: 'entities:passportData.attributes.type.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'select',
      selectOptions: [
        {
          label: 'entities:passportData.attributes.type.selectOptions.PASSPORT.label',
          value: 'PASSPORT',
        },
        {
          label: 'entities:passportData.attributes.type.selectOptions.IDCARD.label',
          value: 'IDCARD',
        },
      ],
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    number: {
      name: 'number',
      label: 'entities:passportData.attributes.number.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    birthPlace: {
      name: 'birthPlace',
      label: 'entities:passportData.attributes.birthPlace.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    issuePlace: {
      name: 'issuePlace',
      label: 'entities:passportData.attributes.issuePlace.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    issueDate: {
      name: 'issueDate',
      label: 'entities:passportData.attributes.issueDate.label',
      type: 'value',
      dataType: 'Date',
      defaultInput: true,
      inputType: 'date',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    validUntil: {
      name: 'validUntil',
      label: 'entities:passportData.attributes.validUntil.label',
      type: 'value',
      dataType: 'Date',
      defaultInput: true,
      inputType: 'date',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
  },
}

export default passportDataModel
